module.exports = __webpack_public_path__ + "static/media/uprez.f51f5d5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/uprez.svg
// module id = 1054
// module chunks = 0